/* Legacy Setster widget loader.

   The widget does not render below 768px. The previous live theme handled this by
   hiding it on mobile and linking out to pearlparadise.setster.com instead. Same
   approach here, but the fallback is styled to match the page.

   The widget script only loads when the viewport is wide enough, so mobile visitors
   are not made to download something they cannot use. If the viewport later crosses
   768px, from a rotation or a resized window, it boots then. */

(function(){
  var DESKTOP = "(min-width: 768px)";
  var loaded = false;

  function loadWidget(){
    if(loaded) return;
    var wrap = document.getElementById("setster-wrapper");
    if(!wrap) return;
    loaded = true;

    var setsHost = "https://www.setster.com/widget/";

    var script = document.createElement("script");
    script.src = setsHost + "js/setster_over.js?v=2";
    script.type = "text/javascript";
    script.charset = "utf-8";

    script.onload = function(){
      if(!window.Setster || !Setster.setster_widget){
        console.error("[setster] widget script loaded but Setster.setster_widget was undefined");
        return;
      }
      try{
        window.setster_widget = new Setster.setster_widget({
          display: "embed",
          uri: "pearlparadise",
          setsterURL: setsHost,
          container: "setster-wrapper",
          returnUrl: "https://www.pearlparadise.com/pages/pearlparadise-virtual-appointments"
        });
      }catch(err){
        console.error("[setster] widget failed to initialise", err);
      }
    };
    script.onerror = function(){
      console.error("[setster] widget script failed to load");
    };

    document.getElementsByTagName("head")[0].appendChild(script);
  }

  function boot(){
    if(!window.matchMedia){ loadWidget(); return; }
    var mq = window.matchMedia(DESKTOP);
    if(mq.matches) loadWidget();
    if(mq.addEventListener){
      mq.addEventListener("change", function(e){ if(e.matches) loadWidget(); });
    }else if(mq.addListener){
      mq.addListener(function(e){ if(e.matches) loadWidget(); });
    }
  }

  if(document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", boot);
  }else{
    boot();
  }
})();
